import React from "react";
import { TbodyListInhabitant, TheadListInhabitant } from "./components";

export default function ListInhabitant({
  access,
  idsToDelete,
  inhabitantSegments,
  setIdsToDelete,
  loading,
  format,
  setIdToDelete,
  setIsOpen,
}) {
  return (
    <table className="contact-table table table-curved table-striped">
      <TheadListInhabitant
        access={access}
        idsToDelete={idsToDelete}
        inhabitantSegments={inhabitantSegments}
        setIdsToDelete={setIdsToDelete}
      />

      <tbody>
        {loading ? (
          <tr>
            <td colSpan="8" className="text-center">
              <i className="fa fa-spinner fa-spin mr-2" /> Carregando,
              aguarde...
            </td>
          </tr>
        ) : (
          <TbodyListInhabitant
            access={access}
            idsToDelete={idsToDelete}
            inhabitantSegments={inhabitantSegments}
            setIdsToDelete={setIdsToDelete}
            format={format}
            setIdToDelete={setIdToDelete}
            setIsOpen={setIsOpen}
          />
        )}
      </tbody>
      <tfoot>
        <tr>
          <th colSpan="8" />
        </tr>
      </tfoot>
    </table>
  );
}
